import { casaDe, type MonedaDeLaCasa } from '@/lib/athena';
import { useWorkspaceStore } from '@/store/workspace.store';

/** La moneda en que trabaja el negocio activo (ver `casaDe`). Mientras no se sabe cuál es, pesos, como antes. */
export function useMonedaDeLaCasa(): MonedaDeLaCasa {
  return useWorkspaceStore((s) => casaDe(s.items.find((w) => w.id === s.activeId)?.currencyPrefix));
}
